import { Trans } from "react-i18next"

import util from "utils/utils"

export default function MentionedContent({ notification, events, notificationType, mentions = [] }) {
  const mentionedInfo = mentions.find((f) => f.type === notificationType)

  const hasType = notification[mentionedInfo?.id]
  if (hasType) {
    const letter = mentionedInfo.id.charAt(0).toUpperCase()
    const ownerName = `owner${letter}${mentionedInfo.id.slice(1)}`
    const ownerItem = notification[ownerName]

    if (ownerItem) {
      return (
        <Trans
          i18nKey="notifications.mentionedComment"
          values={{
            name: util.getEventNames(events),
            mentionedInfo: `mentioned you in the ${mentionedInfo.id}`,
            mentionedName: ownerItem?.name || ownerItem?.title || "Deleted",
          }}
          components={{ b: <b /> }}
        />
      )
    }
  }

  return (
    <Trans
      i18nKey="notifications.mentionedComment"
      values={{
        name: util.getEventNames(events),
        mentionedInfo: mentionedInfo ? mentionedInfo.message : "No message found",
      }}
      components={{ b: <b /> }}
    />
  )
}
